import { RegistrationTypeModel } from '../../api/models';
import { VisibilityFunctions } from '../types';

export const showPrefilledMessage = (values: RegistrationTypeModel) => values.isPrefilled === true;

export const registrationType: VisibilityFunctions<RegistrationTypeModel> = {
    isPrefilled: showPrefilledMessage,
};
